import BaseApi from "@/api/baseApi";
export default {
  addOrUpdate(form) {
    return BaseApi.post(`/api-piglet/api/zsdb-metadata/v1/`, form)
  },
  createPackage(form) {
    return BaseApi.post(`/api-piglet/api/zsdb-package/v1/`, form)
  },
  fetchTodo(owner) {
    return BaseApi.get(`/api-piglet/api/zsdb-metadata/v1/undone?owner=${owner}`);
  },
  fetchPackageId(packageId) {
    return BaseApi.get(`/api-piglet/api/zsdb-metadata/v1/package/${packageId}`);
  },
  fetchTransports() {
    return BaseApi.get(`/api-piglet/api/zsdb-transports/v1/`)
  },
  fetchReasons() {
    return BaseApi.get(`/api-piglet/api/zsdb-reasons/v1/`)
  },
  sendPackage(id) {
    return BaseApi.put(`/api-piglet/api/zsdb-package/v1/send/${id}`)
  },
  removeMetadata(id) {
    return BaseApi.delete(`/api-piglet/api/zsdb-metadata/v1/${id}`)
  },
}
